"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderReceiptLoyaltySectionHTML = exports.renderTenderedPointsRowHTML = exports.renderRedeemedPointsRowHTML = void 0;
const receiptLoyalty_1 = require("./receiptLoyalty");
/** Markup only — the minus-sign rule lives in `formatRedeemedPointsForPaymentLine`. */
const renderRedeemedPointsRowHTML = (receiptLoyalty, paymentLineId) => {
    const redeemedPoints = (0, receiptLoyalty_1.formatRedeemedPointsForPaymentLine)(receiptLoyalty, paymentLineId);
    if (redeemedPoints === null) {
        return '';
    }
    return `
                  <tr>
                    <td colspan=3 style='text-align: right; word-break: keep-all;'>${redeemedPoints}</td>
                  </tr>
                  `;
};
exports.renderRedeemedPointsRowHTML = renderRedeemedPointsRowHTML;
/** Markup only — the gate and the minus-sign rule live in `formatTenderedPoints`. */
const renderTenderedPointsRowHTML = (receiptLoyalty, loyaltyData, points, isRefund) => {
    const tenderedPoints = (0, receiptLoyalty_1.formatTenderedPoints)(receiptLoyalty, loyaltyData, points, isRefund);
    if (tenderedPoints === null) {
        return '';
    }
    return `
                    <tr>
                      <td colspan=3 style='text-align: right;'>${tenderedPoints}</td>
                    </tr>
                  `;
};
exports.renderTenderedPointsRowHTML = renderTenderedPointsRowHTML;
const renderReceiptLoyaltySectionHTML = (receiptLoyalty, isRefund) => {
    const section = (0, receiptLoyalty_1.getReceiptLoyaltySection)(receiptLoyalty, isRefund);
    if (section === null) {
        return '';
    }
    const rows = section.rows
        .map((row) => `
            <tr style='margin-top: 1.5rem; border-top: solid; border-width: 1px;'>
              <td>${row.label}</td>
              <td colspan=2 style='text-align: right; white-space: nowrap;'>${row.value}</td>
            </tr>`)
        .join('');
    const note = section.note === null
        ? ''
        : `
            <tr>
              <td colspan=3>${section.note}</td>
            </tr>`;
    return `${rows}${note}
          `;
};
exports.renderReceiptLoyaltySectionHTML = renderReceiptLoyaltySectionHTML;
//# sourceMappingURL=receiptLoyaltyHtml.js.map